import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { company, navLinks, services } from '../mock/mock';

const Footer = () => {
  return (
    <footer className="bg-neutral-950 text-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-10 mb-16">
          <div className="lg:col-span-4">
            <div className="mb-6">
              <img
                src="/media/caprock-logo.png"
                alt="Caprock Logistics Group"
                className="h-14 w-auto invert"
              />
            </div>
            <p className="font-body text-white/70 text-sm leading-relaxed max-w-sm">
              A West Texas trucking company built by drivers, for shippers who care when their freight actually shows up.
            </p>
          </div>

          <div className="lg:col-span-2">
            <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/50 mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <Link to={l.href} className="font-body text-sm text-white/85 hover:text-white transition-colors">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/50 mb-5">
              Services
            </div>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s.id}>
                  <Link to={`/services#${s.id}`} className="font-body text-sm text-white/85 hover:text-white transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-white/50 mb-5">
              Dispatch
            </div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <span>{company.address}</span>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <Phone className="w-4 h-4 flex-shrink-0" />
                <a href={`tel:${company.phone}`} className="hover:text-white">{company.phone}</a>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <Mail className="w-4 h-4 flex-shrink-0" />
                <a href={`mailto:${company.email}`} className="hover:text-white">{company.email}</a>
              </li>
              <li className="flex items-center gap-3 text-white/80">
                <Clock className="w-4 h-4 flex-shrink-0" />
                <span>{company.hours}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-white/50">
            © {new Date().getFullYear()} Caprock Logistics Group · All Rights Reserved
          </div>
          <div className="flex items-center gap-6 font-mono-tech text-[10px] tracking-[0.25em] uppercase text-white/50">
            <span>DOT #3841902</span>
            <span>MC #1207834</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
